import React from "react";
import styled, { css } from "styled-components";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery";
import typographySizes from "styles/typographySizes.js";
import colors from "styles/colors.js";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import { Link } from "gatsby";

//assets
import arrowIcon from "assets/svg/arrow-btn-2.svg";

const sharedStyles = css`
padding: 1.2rem 2rem;
color: ${colors.dark};
text-decoration: none;
font-size: ${typographySizes.text.tekstSize1.size.desktop}rem;
background-color: ${props => props.color || colors.yellow};
border-radius: 0.4rem;
display: inline-flex;
gap: 0.8rem;
transition: all 0.3s ease-in-out;
&:hover {
  border-radius: 7rem;
  transition: all 0.3s ease-in-out;
}



`;

const StyledLink = styled.a`
  ${sharedStyles}
`;

const StyledGatsbyLink = styled(Link)`
  ${sharedStyles}
`;

const StyledScrollLink = styled(ScrollLink)`
  ${sharedStyles}
`;


const normalizeHref = rawHref => {
  if (!rawHref || typeof rawHref !== "string") {
    return rawHref;
  }

  const trimmed = rawHref.trim();
  const lower = trimmed.toLowerCase();

  if (lower.startsWith("mailto:") || lower.startsWith("tel:")) {
    return trimmed;
  }

  const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
  if (isEmail) {
    return `mailto:${trimmed}`;
  }

  const isPhone = /^\+?[\d\s().-]{6,}$/.test(trimmed);
  if (isPhone) {
    return `tel:${trimmed}`;
  }

  if (lower.startsWith("www.")) {
    return `https://${trimmed}`;
  }

  return trimmed;
};

const BtnSec = ({ color, scroll, pageLink, to, children, href, icon, ...props }) => {
  const content = (
    <>


      {children}
      {icon && <img src={arrowIcon} alt="Arrow" />}
    </>
  );

  if (scroll) {
    return (
      <StyledScrollLink color={color} to={to} smooth={true} duration={500} {...props}>
        {content}
      </StyledScrollLink>
    );
  }

  if (pageLink) {
    return (
      <StyledGatsbyLink color={color} to={to} {...props}>
        {content}
      </StyledGatsbyLink>
    );
  }

  const normalizedHref = normalizeHref(href);

  return (
    <StyledLink color={color} href={normalizedHref} {...props}>
      {content}
    </StyledLink>
  );
};

export default BtnSec;
